module.exports = __webpack_public_path__ + "static/media/bannerRecomendaCaldasNovas.8973a815.jpg";